/* DMM 2026-10-29. Jewelry bag page (sections/dw-nj-cart.liquid). Every write on the page is a native form POST
   that returns to the bag (return_to) or goes to checkout, so the page works without this file.
   This file only (1) blocks a second submit while the first write is in flight, so a double tap cannot send two
   writes, and (2) adds return_to to any Gifts under $350 form that lacks it. No fetch, no retries.
   The submitting button is not disabled, because a disabled submitter would drop its quantity value. */
(() => {
  'use strict';
  const bag = document.querySelector('[data-dw-nj-bag]');
  if (!bag) return;
  const back = bag.dataset.returnTo;
  if (back) {
    bag.querySelectorAll('form[data-dw-addons-form]').forEach((form) => {
      if (form.querySelector('input[name="return_to"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      input.value = back;
      form.appendChild(input);
    });
  }
  let busy = false;
  const reset = () => {
    busy = false;
    bag.classList.remove('is-busy');
    bag.removeAttribute('aria-busy');
  };
  bag.addEventListener('submit', (event) => {
    if (busy) {
      event.preventDefault();
      return;
    }
    busy = true;
    bag.classList.add('is-busy');
    bag.setAttribute('aria-busy', 'true');
  });
  // Back/forward cache can restore a page that was mid-submit; make it usable again.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) reset();
  });
})();
